import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';

import Link from '../../../../shared/_TBComponents/Link';
import Text from '../../../../shared/_TBComponents/Text';

const AgreementFieldError = styled('div')`
  color: #ff6600;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 2px;
`;

const AgreementFormGroup = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  .team-agreement {
    margin-top: 10px;
  }
`;

const InnerAgreementFormGroup = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-left: 5px;
`;

const AcceptAgreementField = ({
  error,
  setFieldValue,
  showAgeNotice,
  touched,
  values,
}) => {
  const theme = useTheme();

  return (
    <AgreementFormGroup>
      <InnerAgreementFormGroup>
        <input
          checked={values.acceptAgreement}
          className='checkbox'
          name='acceptAgreement'
          onChange={() => {
            setFieldValue('acceptAgreement', !values.acceptAgreement && true);
          }}
          type='checkbox'
        />
        <div style={{
          fontWeight: 'bold',
          marginLeft: '5px',
          marginTop: '1px',
        }}
        >
          <Text styledTextProps={{ fontSize: theme.textFontSizes[0] }}>
            I acknowledge and agree to the
            {' '}
            <Link color={theme.colors.orange} href='https://www.teambuildr.com/user-agreement' target='_blank'>TeamBuildr User Agreement</Link>
          </Text>
        </div>
      </InnerAgreementFormGroup>
      {error && touched && (
        <AgreementFieldError>
          Must accept terms before creating account
        </AgreementFieldError>
      )}
      {showAgeNotice ? (
        <Text
          styledTextProps={{ fontSize: theme.textFontSizes[0] }}
          styledWrapperProps={{
            alignSelf: 'center',
            marginTop: '10px',
            maxWidth: '475px',
            textAlign: 'center',
          }}
        >
          Please note, you
          {' '}
          <b>must be at least 13 years old</b>
          {' '}
          to use this application.
          For more information see our
          {' '}
          <Link color={theme.colors.orange} href='https://www.teambuildr.com/user-agreement' target='_blank'>User Agreement</Link>
          {' '}
          and our
          {' '}
          <Link color={theme.colors.orange} href='https://www.teambuildr.com/privacy-policy' target='_blank'>Privacy Policy</Link>
        </Text>
      ) : null}
    </AgreementFormGroup>
  );
};

AcceptAgreementField.propTypes = {
  error: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  showAgeNotice: PropTypes.bool,
  touched: PropTypes.bool,
  values: PropTypes.shape({
    acceptAgreement: PropTypes.bool,
  }).isRequired,
};

AcceptAgreementField.defaultProps = {
  error: '',
  showAgeNotice: true,
  touched: false,
};

export default AcceptAgreementField;
